import { render, staticRenderFns } from "./accordion-item.vue?vue&type=template&id=e26eeb3a&scoped=true&"
import script from "./accordion-item.vue?vue&type=script&lang=js&"
export * from "./accordion-item.vue?vue&type=script&lang=js&"
import style0 from "./accordion-item.vue?vue&type=style&index=0&id=e26eeb3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26eeb3a",
  null
  
)

export default component.exports